import React, { useState } from 'react';
import { useAuth } from 'context/auth/authcontext';
import Loader from 'components/Loader/Loader';

type ErrorState = {
  username: string;
  password: string;
  general?: string; // Add an optional general property
};

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<ErrorState>({
    username: '',
    password: '',
  });
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let isValid = true;
    const newError: ErrorState = { username: '', password: '' };

    if (username.trim().length < 3) {
      newError.username = 'Username must be at least 3 characters long';
      isValid = false;
    }
    if (password.trim().length < 6) {
      newError.password = 'Password must be at least 6 characters long';
      isValid = false;
    }

    setError(newError);
    return isValid;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true); // Show loader

    try {
      await login({ email: username, password }); // Await login if it's async
    } catch (err) {
      setError((prevError) => ({
        ...prevError,
        general: 'Login failed. Please check your credentials.',
      }));
    } finally {
      setLoading(false); // Always hide loader
    }
  };

  return (
    <div className='sign-up-container'>
      <div className='form-container'>
        <div className='title-container'>
          <img
            height='40px'
            src='https://notifygridmedia.s3.us-east-2.amazonaws.com/black+R+transparent.png'
            alt='roloniumlabs logo'
          />
          <h2 className='form-title'>Login</h2>
          <p>Property Management System</p>
        </div>
        <form className='form' onSubmit={handleSubmit}>
          <div>
            {/* <label htmlFor='username'>Email</label> */}
            <input
              type='text'
              placeholder='Email'
              id='username'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className={error.username ? 'input-error' : ''}
            />
            {error.username && <p className='error'>{error.username}</p>}
          </div>

          <div>
            {/* <label htmlFor='password'>Password</label> */}
            <input
              type='password'
              placeholder='Password'
              id='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={error.password ? 'input-error' : ''}
            />
            {error.password && <p className='error'>{error.password}</p>}
          </div>

          {error.general && <p className='error general'>{error.general}</p>}
          {loading ? (
            <Loader />
          ) : (
            <button
              className='btn primary-btn'
              type='submit'
              disabled={loading}
            >
              Login
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
